export default __webpack_public_path__ + "static/media/combo.e48e682b.png";